import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import builderConstructor from '@components/ui-components/builder/constructor/component.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'banner-btn-cmp': BannerBtn,
    'builder-constructor': builderConstructor,
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      const path = to.path.replace(router.history.base, '')
      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          this.template = data.data
        },
        () => {
          next('/404')
        }
      )
    } else next()
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/services/view/index.js